.title {
  font:
    3.125rem/3.75rem Rubik,
    sans-serif;
}

.authContent {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow: hidden;
  margin: 0 0 60px;
}
